export default __webpack_public_path__ + "static/media/standsExpo_siemens energy.9948ee93.jpg";